module.exports = __webpack_public_path__ + "static/media/Olx-pic-R.01fd79ca.PNG";